<template>
  <TracksUser />
</template>

<script>
import TracksUser from '../components/TracksUser'
import {mapActions} from "vuex";

export default {
  components: {
    TracksUser
  },
  methods: {
    ...mapActions('trackImport', ['getCountries'])
  },
  async created() {
    await this.getCountries()
  }
}
</script>
